(() => {
  const script = document.currentScript;
  const root = script && script.previousElementSibling;
  if (!root || !root.matches('[data-tan-event-setup]') || root.dataset.eventSetupReady) return;

  root.dataset.eventSetupReady = 'true';

  const preview = root.querySelector('[data-event-setup-preview]');
  const choices = Array.from(root.querySelectorAll('[data-event-setup-choice]'));
  const resultHeading = root.querySelector('[data-event-setup-heading]');
  const resultCopy = root.querySelector('[data-event-setup-copy]');
  const resultList = root.querySelector('[data-event-setup-list]');

  const payloadFor = (choice) =>
    Array.from(root.querySelectorAll('[data-event-setup-payload]')).find(
      (payload) => payload.dataset.eventSetupPayload === choice.dataset.scenarioId,
    );

  const updateMetric = (key, choice) => {
    const label = root.querySelector(`[data-event-metric-label="${key}"]`);
    const value = root.querySelector(`[data-event-metric-value="${key}"]`);
    const labelKey = `${key}Label`;
    const valueKey = `${key}Value`;
    if (label) label.textContent = choice.dataset[labelKey] || '';
    if (value) value.textContent = choice.dataset[valueKey] || '';
  };

  const updateScenario = (choice) => {
    if (!choice || !preview) return;

    choices.forEach((candidate) => {
      const selected = candidate === choice;
      candidate.classList.toggle('is-active', selected);
      candidate.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    preview.dataset.mode = choice.dataset.modeKey || 'single';
    if (resultHeading) resultHeading.textContent = choice.dataset.scenarioTitle || '';
    if (resultCopy) resultCopy.textContent = choice.dataset.scenarioNote || '';

    const payload = payloadFor(choice);
    const content = payload && payload.content.querySelector('[data-event-setup-checklist]');
    if (resultList) resultList.innerHTML = content ? content.innerHTML : '';

    ['mount', 'pack', 'reuse'].forEach((key) => updateMetric(key, choice));
  };

  choices.forEach((choice) => choice.addEventListener('click', () => updateScenario(choice)));
  updateScenario(choices.find((choice) => choice.classList.contains('is-active')) || choices[0]);
})();
